import React from "react";
import FontAwesome from "react-fontawesome";
import hive200 from "../../assets/spinner/hive200.svg";
import { EnvironmentContext } from "../themes/environment";
import { withI18n } from "../../withI18n";

export const GenericSpinner = ({ style = {}, size = 200, small = false }) => {
  if (small) {
    size = 32;
  }
  return (
    <FontAwesome
      name="spinner"
      spin
      style={{ fontSize: `${size}px`, ...style }}
    />
  );
};

export const HivewatchSpinner = ({ style = {}, size = 200, small = false }) => {
  if (small) {
    size = 32;
  }
  return (
    <span
      style={{
        background: `url(${hive200}) no-repeat top left`,
        backgroundSize: "contain",
        width: `${size}px`,
        height: `${size}px`,
        display: "inline-block",
        ...style,
      }}
    ></span>
  );
};

const selectSpinner =
  (props) =>
  ({ theme }) => {
    switch (theme) {
      case "hivewatch":
        return <HivewatchSpinner {...props} />;
      default:
        return <GenericSpinner {...props} />;
    }
  };

export const Spinner = (props) => (
  <EnvironmentContext.Consumer children={selectSpinner(props)} />
);

export const SpinnerBox = withI18n()(
  ({ i18n, text = i18n.t({ id: `base.loading` }) }) => (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "6px 6px 0 0",
        padding: "10px",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "20px",
      }}
    >
      <Spinner />
      <p>{text}</p>
    </div>
  ),
);
